import styled from "styled-components"

const EventsItemImg = styled.div`
  &::before {
    background-color: ${(props) => props.theme.b_color_gradients.b_light}CC;
  }
`

const Taxo = styled.div`
  color: ${(props) => props.theme.b_color_gradients.b_dark};
`

const StyledDate = styled.p`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
  margin-bottom: 0;
`

const EventsItemTitle = styled.div`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
`

export { EventsItemImg, Taxo, StyledDate, EventsItemTitle }
